// extracted by mini-css-extract-plugin
export default {"automaticallyAdded":"FormikTags_automaticallyAdded__v4AGV"};